import React, { VFC } from 'react';
import styled from 'styled-components';

import { V1UsersitePlansAtmosphereSliderManyTypePayload } from '~/models/schema';
import AtmosphereSlider from './AtmosphereSlider';

interface Props {
  atmosphereSliders: V1UsersitePlansAtmosphereSliderManyTypePayload;
}
const AtmosphereSliders: VFC<Props> = ({ atmosphereSliders }: Props) => {
  const { firstHalf, latterHalf } = atmosphereSliders.reduce(
    (prevValue, currentValue, index) => {
      const halfIndex = 4;
      index <= halfIndex
        ? prevValue.firstHalf.push(currentValue)
        : prevValue.latterHalf.push(currentValue);
      return prevValue;
    },
    { firstHalf: [], latterHalf: [] } as {
      firstHalf: V1UsersitePlansAtmosphereSliderManyTypePayload;
      latterHalf: V1UsersitePlansAtmosphereSliderManyTypePayload;
    },
  );

  return (
    <Wrapper>
      <LeftSliderWrapper>
        {firstHalf.map((v) => (
          <AtmosphereSlider atmosphereSlider={v} key={v.kind} />
        ))}
      </LeftSliderWrapper>

      <RightSliderWrapper>
        {latterHalf.map((v) => (
          <AtmosphereSlider atmosphereSlider={v} key={v.kind} />
        ))}
      </RightSliderWrapper>
    </Wrapper>
  );
};

export default AtmosphereSliders;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
  }
`;
const LeftSliderWrapper = styled.div`
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-right: ${({ theme }) => theme.spacing(4)}px;
  }
`;
const RightSliderWrapper = styled.div`
  width: 100%;
`;
